import { NetworkRequestState } from '../baseTypes';
import {
  DeactivateAccountWidgetData,
  DeactivateAccountWidgetStep,
} from './types';

export const defaultDeactivateAccountWidgetState: DeactivateAccountWidgetData =
  {
    step: DeactivateAccountWidgetStep.Initial,
    canReactivate: false,
    isDeactivated: false,
    timeUntilReactivation: 0,
    timeUntilReactivationEnds: 0,
    linkSource: 'settings',
    email: '',
    confirmation: undefined,
    request: { status: NetworkRequestState.IDLE, errors: {} },
  };
